import { Box, Typography, Link } from "@mui/material";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import { useAnimation } from "../contexts/AnimationContext";

function Drivers() {
  const ref = useRef(null);
  const { animationStarted } = useAnimation();
  const isInView = useInView(ref, { once: true, margin: "0px" });

  return (
    <Box
      component={motion.div}
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={
        isInView && animationStarted
          ? { opacity: 1, y: 0 }
          : { opacity: 0, y: 30 }
      }
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      sx={{ mt: { xs: 6, md: 6 }, mb: 0 }}
    >
      <Typography
        variant="h5"
        sx={{
          fontFamily: '"Open Sans", sans-serif',
          fontSize: { xs: "1.35rem", sm: "1.5rem" },
          fontWeight: 400,
          color: "#1a3a52",
          mb: 3,
          textAlign: { xs: "center", md: "center" },
          // ml: { xs: 0, md: 7 },
        }}
      >
        Serviços de Motoristas
      </Typography>

      {/* José Castelo Branco */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: '"Open Sans", sans-serif',
            fontSize: { xs: "1.1rem", sm: "1.2rem" },
            fontWeight: 500,
            color: "#1a3a52",
            mb: 1,
            textAlign: "center",
          }}
        >
          José Castelo Branco
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Link
            href="tel:+351935357137"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              textDecoration: "none",
              color: "#1a3a52",
              "&:hover": {
                color: "#2d4e66",
              },
            }}
          >
            <PhoneIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
            <Typography
              variant="body2"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: { xs: "0.95rem", sm: "1rem" },
              }}
            >
              +351 935 357 137
            </Typography>
          </Link>
        </Box>
      </Box>

      <Typography
        variant="body1"
        align="justify"
        sx={{
          fontFamily: '"Open Sans", sans-serif',
          fontSize: { xs: "1rem", sm: "1.1rem" },
          lineHeight: 2,
          color: "#2d4e66",
          mx: { xs: 0, sm: 0, lg: 4 },
          mb: { xs: -1, sm: 0, md: 0, lg: 0 },
        }}
      >
        Para que possam aproveitar o casamento sem preocupações, coordenámos um
        serviço de motoristas que estará disponível no dia para vos levar de
        volta a casa em segurança. Entrem em contacto com o José para todas as
        informações e preços.
      </Typography>

      {/* Stardrivers */}
      {/* <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: '"Open Sans", sans-serif',
            fontSize: { xs: "1.1rem", sm: "1.2rem" },
            fontWeight: 500,
            color: "#1a3a52",
            mb: 1,
            textAlign: "center",
          }}
        >
          Stardrivers
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            alignContent: "center",
            gap: 1,
          }}
        >
          <Link
            href="tel:+351918018898"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              textDecoration: "none",
              color: "#1a3a52",
              "&:hover": {
                color: "#2d4e66",
              },
            }}
          >
            <PhoneIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
            <Typography
              variant="body2"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: { xs: "0.95rem", sm: "1rem" },
              }}
            >
              +351 918 018 898
            </Typography>
          </Link>
        </Box>
      </Box> */}
    </Box>
  );
}

export default Drivers;
